export default __webpack_public_path__ + "static/media/logo.51c2fdab.svg";